import { useMutation, useQueryClient } from "@tanstack/react-query";
import { FILTER_VALUES } from "@/constants/filters";
import { queryKeys } from "@/constants/queryKeys";
import { useCustomerScopedQuery } from "@/hooks/useCustomerScopedQuery";
import { useToast } from "@/hooks/useToast";
import { services } from "@/services/registry";
export const useApiKeys = (productCode, enabled = true, customerIdOverride)=>{
    return useCustomerScopedQuery({
        queryKey: [
            ...queryKeys.apiKeys.list(productCode || FILTER_VALUES.ALL),
            customerIdOverride ?? "customer-scope"
        ],
        queryFn: ({ customerId })=>services.apiKeysService.getAllApiKeys(productCode, customerIdOverride ?? customerId),
        enabled,
        staleTime: 5 * 60 * 1000
    });
};
export const useCreateApiKey = (productCode)=>{
    const queryClient = useQueryClient();
    const toast = useToast();
    return useMutation({
        mutationFn: ({ data, productCodeForKey })=>services.apiKeysService.createApiKey(productCodeForKey || productCode, data),
        onSuccess: (result)=>{
            queryClient.invalidateQueries({
                queryKey: queryKeys.apiKeys.all()
            });
            queryClient.invalidateQueries({
                queryKey: [
                    "available-products"
                ]
            });
            return result;
        },
        onError: (error)=>{
            if (error?.response?.data?.error) {
                toast.error(error.response.data.error);
            } else {
                toast.handleApiError(error, "Failed to create API key");
            }
        }
    });
};
export const useDeleteApiKey = ()=>{
    const queryClient = useQueryClient();
    const toast = useToast();
    return useMutation({
        mutationFn: ({ keyId, productCode })=>services.apiKeysService.deleteApiKey(productCode, keyId),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: queryKeys.apiKeys.all()
            });
            queryClient.invalidateQueries({
                queryKey: [
                    "available-products"
                ]
            });
            toast.success("API key deleted successfully");
        },
        onError: (error)=>{
            toast.handleApiError(error, "Failed to delete API key");
        }
    });
};
export const useUpdateApiKeyStatus = ()=>{
    const queryClient = useQueryClient();
    const toast = useToast();
    return useMutation({
        mutationFn: ({ keyId, productCode, action })=>services.apiKeysService.updateApiKeyStatus(productCode, keyId, action),
        onSuccess: (_, { action })=>{
            queryClient.invalidateQueries({
                queryKey: queryKeys.apiKeys.all()
            });
            queryClient.invalidateQueries({
                queryKey: [
                    "available-products"
                ]
            });
            toast.success(`API key ${action}d successfully`);
        },
        onError: (error, { action })=>{
            toast.handleApiError(error, `Failed to ${action} API key`);
        }
    });
};
